module.exports = __webpack_public_path__ + "static/media/style-quiz.6bb32617.mp4";